import React from 'react';
import {reduxForm} from 'redux-form';
import AlertIconCell from '../../../Common/CustomGridCells/AlertIconCell/alertIconCell';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';
import Grid from 'infrastructure/js/components/Grid/gridWrapper';
import MultiRowsCell from 'infrastructure/js/components/Grid/MulitRowsCell/multiRowsCell';
import LabelWithTooltipCell from '../../../Common/CustomGridCells/LabelWithTooltipCell/labelWithTooltipCell.js';
import {navigationStates} from '../../../../enums/navigationStates';
import {filterTypes} from 'infrastructure/js/enums/filterTypes';
import {gridsNames} from '../../../../enums/gridsNames';
import {FetchEntitiesFilters} from '../../../../enums/fetchEntitiesFilters';
import {EntityPropertyTypes} from '../../../../enums/entityPropertyTypes';
import EntityIdCell from '../../../Common/CustomGridCells/EntityIdCell/entityIdCell';
import {alertStatus, alertType, getAlertColumnFilterSections} from '../../../../utils/alertFilterSectionHelper';
import * as AlertHelper from '../../../../utils/alertHelper';
import {filterAlignmentTypes} from 'infrastructure/js/enums/filterAlignmentTypes';

require('./alertedGroupsGrid.scss');

class AlertedGroupsGrid extends React.PureComponent {

  filterConfig = [
    {fieldName: 'alertStatus', filterName: 'assetAlert'},
    {fieldName: 'availability', filterName: 'availabilityStatus', getOptions: true},
    {fieldName: 'businessId', filterName: 'businessId' ,getOptions: false},
    {fieldName: 'groupType.businessId', filterName: 'groupType', getOptions: true},
    {fieldName: 'location', filterName: 'assetLocationName', getOptions: true}
  ]

  constructor(props) {
    super(props);
    this.labels = createLabelHelper('mat.grid.');

    this.columnsConfig = this.createColumnsConfig();
  }

  createColumnsConfig = () => {
    return [
      {
        fieldName: 'alertStatus',
        title: this.labels.get('columns.severity.title'),
        filterType: filterTypes.MULTI_SECTIONS,
        filterSections: getAlertColumnFilterSections([alertStatus.WARNING,alertStatus.ERROR],
          [alertType.ETL_BOND,alertType.ETL_CURE,alertType.EXPIRATION,alertType.DUE_DATE, alertType.MISPLACED]),
        width: 150,
        filterName: 'assetAlert',
        columnOptions: {
          sort: 'desc',
          cellComponent: MultiRowsCell,
          valueGetter: (params) => {
            return {
              dataList: params.data.alerts,
              componentType: AlertIconCell
            };
          }
        },
      },
      {
        fieldName: 'assetStatus',
        title: this.labels.get('columns.alert.type.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: MultiRowsCell,
          valueGetter: (params) => {
            return {
              dataList: params.data.alerts.map(alert => (AlertHelper.getAlertTypeDisplayName(alert.alertType))),
              componentType: LabelWithTooltipCell
            };
          }
        },
      },
      {
        fieldName: 'value',
        title: this.labels.get('columns.value.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: MultiRowsCell,
          valueGetter: (params) => {
            return {
              dataList: params.data.alerts.map(alert =>  (alert.m_value)),
              componentType: LabelWithTooltipCell
            };
          }
        }
      },
      {
        fieldName: 'availability',
        title: this.labels.get('columns.status.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'availabilityStatus',
        width: 130,
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
          valueGetter: (params) => {
            return this.getAvailabilityLabel(params.data.availability)
          }
        }
      },
      {
        fieldName: 'businessId',
        title: this.labels.get('columns.groupId.title'),
        filterType: filterTypes.MULTI_SELECT_ASYNC,
        filterName: 'businessId',
        fetchConfig: {
          entityType: EntityPropertyTypes.GROUP_BUSINESS_ID,
          filter: [FetchEntitiesFilters.ACTIVE, FetchEntitiesFilters.ALERTED],
          action: this.props.actions.fetchEntities
        },
        columnOptions: {
          cellComponent: EntityIdCell,
          valueGetter: (params) => {
            return {
              id: params.data.id,
              type: navigationStates.GROUP,
              label: params.data.businessId
            };
          }
        }
      },
      {
        fieldName: 'groupType.businessId',
        title: this.labels.get('columns.type.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'groupType',
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
          valueGetter: (params) => {
            return (params.data.groupType?.businessId || '');
          },
        }
      },
      {
        fieldName: 'location',
        title: this.labels.get('columns.location.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'assetLocationName',
        filterAlignment: filterAlignmentTypes.RIGHT,
        columnOptions: {
          cellComponent: EntityIdCell,
          valueGetter: (params) => {
            return {
              id: params.data.locationId,
              type: navigationStates.LOCATION,
              label: params.data.locationName
            };
          }
        }
      }
    ]
  }

  getAvailabilityLabel(availability) {
    if (availability === 'AVAILABLE') {
      return this.labels.get('columns.status.filter.available');
    }
    else if (availability === 'OCCUPIED') {
      return this.labels.get('columns.status.filter.occupied');
    }
    return '';
  }

  getRowHeight(params) {
    let rowHeight = 64;
    if (params.data.alerts.length > 1) {
      rowHeight = params.data.alerts.length * 30 + 40;
    }
    return rowHeight;
  }

  render() {
      return (
        <div className="alerted-groups-grid">
          <Grid gridName={gridsNames.PREDEFINED_LIST_ALERTED_GROUPS}
                columnsConfig={this.columnsConfig}
                actions={this.props.actions}
                filterConfig={this.filterConfig}
                gridProps={
                  {
                    getRowHeight: this.getRowHeight,
                    filterPersistence: true,
                  }
                }
          >
          </Grid>
        </div>
      );
    }
 }

export default reduxForm({
    form: 'alertedGroupsGrid'
  }
)(AlertedGroupsGrid);
